import React, { useState } from 'react'
import classNames from 'classnames';
import '../css/workwithus.css'
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link
  } from "react-router-dom";
  import Button from './Buttons'
  import {FAQCoaching } from './FAQCoaching'
  import { FaQuoteLeft } from 'react-icons/fa';
  import { Helmet } from 'react-helmet';
import { BsFillArrowUpLeftSquareFill } from 'react-icons/bs';
import ChatWidget from './ChatWidget';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";


const CircleCheck = <svg className="CircleCheck" stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"></path><path d="M9.999 13.587 7.7 11.292l-1.412 1.416 3.713 3.705 6.706-6.706-1.414-1.414z"></path></svg>

const Check = <svg className="Check" stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="m10 15.586-3.293-3.293-1.414 1.414L10 18.414l9.707-9.707-1.414-1.414z"></path></svg>
const Cross = <svg className="Cross" stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="m16.192 6.344-4.243 4.242-4.242-4.242-1.414 1.414L10.535 12l-4.242 4.242 1.414 1.414 4.242-4.242 4.243 4.242 1.414-1.414L13.364 12l4.242-4.242z"></path></svg>

class WhyWorkWithUsCoaching extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            activeIndex: null
        }
      }

      componentDidMount = () => {
        window.scrollTo(0, 0)
        console.log("Slider component mounting")
      }

    render() {
      const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        adaptiveHeight: true,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              arrows: false,
              dots: true
            }
          }
        ]
      };

      const handleClick = (index) => {
        this.setState({ activeIndex: this.state.activeIndex === index ? null : index });
      };

      return (
        <div className="WhyWorkWithUsPage">
            <Helmet>
            <meta charSet="utf-8" />
              <title>ArchJobs | Architectural Career Coaching | UK and Dubai</title>
                <link rel="canonical" href={"https://www.archjobs.co.uk/architectural-career-coaching"} />
                <meta name="description" content={"Whether you're struggling with your architectural job search journey in the UK, or you just need some specific advice, working with Aylin will offer you useful insights and actionable advice to help you succeed in navigating your Architectural Career" }/>
                <meta name="og:title" content={"ArchJobs | Architectural Career Coaching | UK and Dubai | With Aylin Round"}/>
                <meta name="og:type" content={"website"}/>
                <meta name="og:image" content={"https://cdn.archjobs.co.uk/file/ArchJobs/backgrounds/archjobs_banner.png"}/>
                <meta name="og:url" content={"https://www.archjobs.co.uk/architectural-career-coaching"}/>
            </Helmet>
          <div className="WhyWorkWithUsBanner WhyWorkWithUsBannerCoaching">
            <div className="WhyWorkWithUsBannerTextContainer">
              <div className="WhyWorkWithUsSectionTitle WhyWorkWithUsSectionTitleBold">Architectural Career Coaching | UK & Dubai</div>
              <div className="WhyWorkWithUsSectionSubtitle">Struggling to position yourself in the UK or Dubai job market?
              I provide clear, tailored advice to help you improve your CV, portfolio and overall strategy, so you can focus on the right steps and move forward with confidence. </div>
              {/* <div className="WhyWorkWithUsSectionSubtitle">Whether you're struggling with your architectural job search journey in the UK, or you just need some specific advice, working with Aylin will offer you useful insights and actionable advice to help you succeed in navigating your Architectural Career.</div> */}
          </div>
          <div className="WhyWorkWithUsBannerBG CoachingBG"> </div>
          </div>
          <div className="WhyWorkWithUsSection" id="ChoosePackageSection">
           <div className="WhyWorkWithUsSectionTitle WhyWorkWithUsSectionTitleBold">Choose a Coaching Package</div>
            <div className="WhyWorkWithUsSectionSubtitle">Explore each package below</div>
             <div className="PricingPackages CoachingPricingPackages">
              <div to="/post?package=basic" className="PostJobPackage" id="cvpack" >
                <div className="PackageTitle">CV Review</div>
                <div className="PackagePrice">£89</div>
                <div className="PackageSubtitle"> Improve your CV and understand what actually matters.</div>
                <div className="PackagePerAd">45-minute session</div>
                <div className="PackageDescription">
                  <div className="PackageDescriptionTitle">Includes</div>
                  <div className="PackageDescriptionText">{Check} Ensuring your CV aligns with the role you are targeting</div>
                  <div className="PackageDescriptionText">{Check} Assessing clarity and suggesting layout improvements to make your CV stand out</div>
                  <div className="PackageDescriptionText">{Check} Insights on what Hiring Managers look for in your CV  (UK or Dubai)</div>
                  <div className="PackageDescriptionText">{Check} Checking layout, format, typos and for ATS-friendliness</div>
                  <div className="PackageDescriptionText">{Check} Offering tailored guidance on improving your CV</div>
                  {/* <div className="PackageDescriptionText">{Check} Feedback via Video Call</div> */}
                </div>
                {/* <div className="StartNowButtonContainer">
                  <Link to="/architectural-career-coaching/check-out?package=cvpack">
                    <Button btnClassName="PostJobButton">Get Started</Button>
                  </Link>
                </div> */}
              </div>
              <div to="/post?package=basic" className="PostJobPackage" id="cvportfoliopack" >
                <div className="PackageTitle">CV + Portfolio Review</div>
                <div className="PackagePrice">£119</div>
                <div className="PackageSubtitle">  Refine both your CV and portfolio so they present your experience clearly.</div>
                <div className="PackagePerAd">60-minute session</div>
                <div className="PackageDescription">
                  <div className="PackageDescriptionTitle">Includes</div>
                  <div className="PackageDescriptionText">{Check} Everything from the Full CV Review package</div>
                  <div className="PackageDescriptionText">{Check} Ensuring your Portfolio aligns with your CV</div>
                  <div className="PackageDescriptionText">{Check} Offering feedback on the layout & overall presentation</div>
                  <div className="PackageDescriptionText">{Check} Ensuring your Portfolio showcases your skills & experience</div>
                  <div className="PackageDescriptionText">{Check} Assessing if project descriptions are clear</div>
                </div>
                {/* <div className="StartNowButtonContainer">
                  <Link to="/architectural-career-coaching/check-out?package=cvportfoliopack">
                    <Button btnClassName="PostJobButton">Get Started</Button>
                  </Link>
                </div> */}
              </div>
              {/* <div to="/post?package=basic" className="PostJobPackage" id="linkedinpack" >
                <div className="PackageTitle">LinkedIn Review</div>
                <div className="PackagePrice">£99</div>
                <div className="PackagePerAd">Whole package</div>
                <div className="PackageDescription">
                  <div className="PackageDescriptionTitle">Includes</div>
                  <div className="PackageDescriptionText">{Check} LinkedIn Profile Review</div>
                  <div className="PackageDescriptionText">{Check} 15min call to understand the role you're aiming for</div>
                  <div className="PackageDescriptionText">{Check} Crafting the perfect LinkedIn Headline and About section</div>
                  <div className="PackageDescriptionText">{Check} Optimising your LinkedIn Profile for maximum visibility</div>
                  <div className="PackageDescriptionText">{Check} Learn how Hiring Managers/Recruiters find candidates on LinkedIn</div>
                </div>
                <div className="StartNowButtonContainer">
                  <Link to="/architectural-career-coaching/check-out?package=linkedinpack">
                    <Button btnClassName="PostJobButton">Get Started</Button>
                  </Link>
                </div>
              </div> */}
              <div to="/post?package=basic" className="PostJobPackage" id="strategy" >
                <div className="PackageTitle">Strategy Call | UK</div>
                <div className="PackagePrice">£169</div>
                <div className="PackageSubtitle"> Get clarity on how to approach the UK job market and position yourself.</div>
                <div className="PackagePerAd">90-minute session</div>
                <div className="PackageDescription">
                  <div className="PackageDescriptionTitle">Includes</div>
                  <div className="PackageDescriptionText">{Check} Market insights and salary guidance for the UK</div>
                  <div className="PackageDescriptionText">{Check} Review of your CV & Portfolio</div>
                  <div className="PackageDescriptionText">{Check} Learn what UK hiring managers look for in an application</div>
                  <div className="PackageDescriptionText">{Check} Tailored support for overcoming your biggest job search hurdles</div>
                  <div className="PackageDescriptionText">{Check} For Relocators: Things you need to know before moving i.e. job titles, cost of living, skilled worker visas...</div>
                </div>
                {/* <div className="StartNowButtonContainer">
                  <Link to="/architectural-career-coaching/check-out?package=strategy">
                    <Button btnClassName="PostJobButton">Get Started</Button>
                  </Link>
                </div> */}
              </div>
              <div to="/post?package=basic" className="PostJobPackage" id="strategy" >
                <div className="PackageTitle">Strategy Call | Dubai</div>
                <div className="PackagePrice">£189</div>
                  <div className="PackageSubtitle"> Understand the Dubai market and how to position yourself effectively.</div>     
                <div className="PackagePerAd">90-minute session</div>
                <div className="PackageDescription">
                  <div className="PackageDescriptionTitle">Includes</div>
                  <div className="PackageDescriptionText">{Check} Market insights and salary guidance for Dubai</div>
                  <div className="PackageDescriptionText">{Check} Review of your CV & Portfolio</div>
                  <div className="PackageDescriptionText">{Check} Learn what hiring managers look for in an application</div>
                  <div className="PackageDescriptionText">{Check} Tailored support for overcoming your biggest job search hurdles</div>
                  <div className="PackageDescriptionText">{Check} For Relocators: Things you need to know before moving i.e. renting, additional costs, attesting your degrees...</div>
                </div>
                {/* <div className="StartNowButtonContainer">
                  <Link to="/architectural-career-coaching/check-out?package=strategydubai">
                    <Button btnClassName="PostJobButton">Get Started</Button>
                  </Link>
                </div> */}
              </div>
              {/* <div to="/post?package=basic" className="PostJobPackage" id="starter" >
                <div className="PackageTitle">Starter Pack</div>
                <div className="PackagePrice">£179</div>
                <div className="PackagePerAd">Whole package</div>
                <div className="PackageDescription">
                  <div className="PackageDescriptionTitle">Includes</div>
                  <div className="PackageDescriptionText">{Check} CV Review</div>
                  <div className="PackageDescriptionText">{Check} Sample Portfolio Review</div>
                  <div className="PackageDescriptionText">{Check} LinkedIn Profile Review </div>
                  <div className="PackageDescriptionText">{Check} + 1 hour Feedback Session</div>
                </div>
                <div className="StartNowButtonContainer">
                  <Link to="/architectural-career-coaching/check-out?package=starter">
                    <Button btnClassName="PostJobButton">Get Started</Button>
                  </Link>
                </div>
              </div> */}
               
              {/* <div to="/post?package=basic" className="PostJobPackage" id="interview" >
                <div className="PackageTitle">Interview Pack</div>
                <div className="PackagePrice">£179</div>
                <div className="PackagePerAd">Whole package</div>
                <div className="PackageDescription">
                  <div className="PackageDescriptionTitle">Includes</div>
                  <div className="PackageDescriptionText">{Check} Interview Preparation</div>
                  <div className="PackageDescriptionText">{Check} Portfolio Presentation Feedback</div>
                  <div className="PackageDescriptionText">{Check} Salary Negotiation Tips</div>
                  <div className="PackageDescriptionText">{Check} + 1.5 hour Coaching Session</div>
                </div>
                <div className="StartNowButtonContainer">
                  <Link to="/architectural-career-coaching/check-out?package=interview">
                    <Button btnClassName="PostJobButton">Get Started</Button>
                  </Link>
                </div>
              </div> */}
            <p/>
            </div>
            <p/>
            <p>Interested in a coaching session? Get in touch and I’ll share availability and next steps.</p>
            <div class="coaching-contact-button">
              <a href="mailto:hello@archjobs.co.uk?subject=Coaching%20Session%20Enquiry" class="btn-get-in-touch">
                Get in Touch
              </a> 
            </div>
           <p/>
            <p/>

            <div className="WhyWorkWithUsSectionTitle">Meet your Coach</div>
            <div className="WhyWorkWithUsSection MeetTheCoach">
              <div className="MeetTheCoachContainer">
                <div className="MeetTheCoachImageContainer">
                  <img 
                    src="https://cdn.archjobs.co.uk/file/ArchJobs/recruiters/Aylin_Round_2026.jpg" 
                    className="Img CoachAuthorImg" 
                    alt="Aylin's Profile Image"
                  />
                </div>
                <div className="MeetTheCoachContent">
                  <h3>Hi, I'm Aylin 👋</h3>
                  <p>After several years working in architectural recruitment across the UK, I launched ArchJobs to help professionals navigate their careers more effectively.</p>
                  <p>I’ve reviewed thousands of CVs and portfolios and worked closely with hiring managers across both markets.</p>
                  <p>Now based in Dubai, I support both UK-based candidates and those looking to relocate. I work closely with hiring managers and stay up to date with market trends - giving you practical, relevant advice you can actually use.</p> 
                  <h3>Who could benefit from working with me?</h3>
                  <ul className="WhoForList">
                  <li>Architectural professionals improving their CV and portfolio</li>
                  <li>Graduates looking to strengthen their applications</li>
                  <li>Overseas-qualified candidates transitioning to the UK or Dubai</li>
                  </ul><h3>My approach?</h3>
                  <p/>
                  <p>I focus on clear, honest and actionable feedback.
                    The goal is simple, to help you present your experience more effectively and understand how to position yourself in the market.</p>
                  <p>I look forward to working with you.</p>
                  <p><b>Aylin</b></p>
                </div>
              </div>
            </div>
          
          </div>
          <div className="WhyWorkWithUsSection GreySection">
            <div className="WhyWorkWithUsSectionTitle">Learn more about each package</div>

            <div className="WhyWorkWithUsCoachingPackage"> 
              <div className = "CoachingPackageTitle">CV Review<span className="CoachingPackageSubtitle"></span> </div>
              <div className="CoachingPackageDescription">
                <p>Do you feel like your CV isn’t getting the response it should?</p>
               <b>What to expect during the session:</b>
                <p>This session is designed to help you understand what’s missing and how to improve it.</p>
                <p>During our call, we’ll go through your CV together - focusing on clarity, structure and how well it aligns with the roles you’re targI won't just save you time, I'll show you how to avoid common mistakes that could make the difference between landing the job or not.eting. I’ll also share what hiring managers actually look for and where candidates often go wrong.</p>
                <p>The goal is simple: to help you present your experience clearly and increase your chances of securing interviews.</p>
              </div>
              {/* <div className="StartNowButtonContainer">
                  <Link to="/architectural-career-coaching/check-out?package=cvpack">
                    <Button btnClassName="PostJobButton">Book Now</Button>
                  </Link>
                </div> */}
            </div>

            <div className="WhyWorkWithUsCoachingPackage"> 
              <div className = "CoachingPackageTitle">CV + Portfolio Review<span className="CoachingPackageSubtitle"></span> </div>
              <div className="CoachingPackageDescription">
                <p>Your CV and portfolio are the two most important documents in your job search - but they’re often the most misunderstood.</p>
               <b>What to expect during the session:</b> 
                <p>In this session, we’ll review both in detail, looking at how your work is presented, how clearly your experience comes across, and whether your portfolio supports the type of roles you’re applying for.</p>
                <p>You’ll leave with clear, practical changes you can implement immediately.</p>
              </div>
              {/* <div className="StartNowButtonContainer">
                  <Link to="/architectural-career-coaching/check-out?package=cvportfoliopack">
                    <Button btnClassName="PostJobButton">Book Now</Button>
                  </Link>
                </div> */}
            </div>

            {/* <div className="WhyWorkWithUsCoachingPackage"> 
              <div className = "CoachingPackageTitle">LinkedIn Review<span className="CoachingPackageSubtitle"></span> </div>
              <div className="CoachingPackageDescription">
                <p>Would you like to optimise your LinkedIn profile to attract more hiring managers and recruiters, but you're unsure if your profile is strong enough or if they can even find you in their searches? </p>
                <p>The LinkedIn Review is ideal for anyone who has recently joined the platform or wants to optimise their profile to attract the right people with the right opportunities. </p>
                <p><b>Here's what you can expect:</b></p>
                <p>The LinkedIn Review Pack is ideal for anyone who has recently joined the platform or wants to optimise their profile to attract the right people with the right opportunities. </p>
                <p>Once I know your goal, I can provide specific advice and guidance on increasing your visibility. This involves using the correct keywords, having a well-written headline and 'about' section, and expanding your professional network.</p>
                <p>As someone who has used LinkedIn to find suitable candidates for previous architectural practices, I know which keywords are crucial and what needs to be included in your profile. Let me help you save time and create a profile that not only looks good but might also increase your chances of finding a new role.</p>
              </div>
              <div className="StartNowButtonContainer">
                  <Link to="/architectural-career-coaching/check-out?package=linkedinpack">
                    <Button btnClassName="PostJobButton">Book Now</Button>
                  </Link>
                </div>
            </div> */}
            <div className="WhyWorkWithUsCoachingPackage"> 
              <div className = "CoachingPackageTitle">Strategy Call | UK <span className="CoachingPackageSubtitle"></span> </div>
              <div className="CoachingPackageDescription">
                <p>If you're unsure how to approach your job search or feel like you're not getting the right results, this session is designed to give you clarity on your next steps.</p>
                <b>What to expect during the session:</b>
                <p>We’ll focus on understanding the UK market, salary expectations, and how to position yourself effectively based on your experience and the roles you're targeting.</p>
                <p>This is not generic advice. You’ll gain practical, honest insights into how hiring managers think, where candidates typically fall short, and what you can do differently to improve your chances.</p>
              </div>
             
            </div>
            <div className="WhyWorkWithUsCoachingPackage"> 
              <div className = "CoachingPackageTitle">Strategy Call | Dubai <span className="CoachingPackageSubtitle"></span> </div>
              <div className="CoachingPackageDescription">
                <p>If you're considering a move to Dubai or want to better understand how the market works, this session is designed to give you clarity on your next steps.</p>
               <b>What to expect during the session:</b>
                <p>We’ll focus on understanding the Dubai market, in-demand skills, and what to expect when relocating - from job search strategy to how roles, expectations and hiring processes differ across markets.</p>
                <p>You’ll gain real insight into how the market operates, what employers are actually looking for and how to position yourself to secure the right opportunity.</p>
              </div>
             
            </div>

             <p/>
            <p>Not sure which session is right for you? Get in touch and I’ll guide you.</p>
            <div class="coaching-contact-button">
              <a href="mailto:hello@archjobs.co.uk?subject=Coaching%20Session%20Enquiry" class="btn-get-in-touch">
                Get in Touch
              </a> 
            </div>
            {/* <div className="WhyWorkWithUsCoachingPackage"> 
              <div className = "CoachingPackageTitle">Full Pack <span className="CoachingPackageSubtitle"> - Everything from the 3 packages plus more</span> </div>
              <div className="CoachingPackageDescription">
                <p>Get everything from all three packages and more. This package is perfect for anyone who wants a more hands on approach or who is not working with a recruiter. I'll be guiding you through all the steps from our initial strategy call to handing in your notice. </p>
                <p><b>Here's what you can expect:</b></p>
                <p><b>Strategy Call:</b> We start with a 1 hour strategy call to understand your current situation, goals, and recommend your next steps.</p>
                <p><b>Application Feedback:</b> Tailoring your CV, Sample Portfolio, and LinkedIn profile to your target role. Ensuring they're keyword-rich, readable, and highlight your strengths.</p>
                <p><b>Interview Prep:</b> Get ready for interviews through video calls. We cover questions, project presentations, and salary negotiations.</p>
                <p><b>Offer Review:</b> Get ready for interviews through video calls. We cover questions, project presentations, and salary negotiations.</p>
                <p><b>Resignation Guidance:</b> If you decide to make a move, I'll guide you on submitting your notice and provide a resignation letter template, ensuring a smooth transition.</p>
                <p>Throughout our coaching, I'm here to assist with anything that comes up and brainstorm ideas. Feel free to reach out at any time with additional questions.</p>
              </div>
              <div className="StartNowButtonContainer">
                  <Link to="/architectural-career-coaching/check-out?package=full">
                    <Button btnClassName="PostJobButton">Book Now</Button>
                  </Link>
                </div>
            </div> */}
              <p/>
           <p/>
          </div>
          {/* <div className="WhyWorkWithUsSection WhyWorkWithUsSectionCall">
          <div className="WhyWorkWithUsSectionTitle">Do you need advice on a different matter?</div>
              <div className="WhyWorkWithUsSectionSubtitle">Let's chat, book your FREE 15 min phone call with Aylin today. </div>
            <div className="WhyWorthWithUsHeaderButton">
              <Link to="/architectural-career-coaching/check-out?package=call">
                <Button btnClassName="PostJobButton">Request a Call</Button>
              </Link>
            </div>
          </div> */}
          <p/>
           <p/>
          <div className="WhyWorkWithUsSectionTestimonials">
            <div className="WhyWorkWithUsSectionTitle">Testimonials</div>
            <div className="WhyWorkWithUsSectionSubtitle">Don't just take my word for it - see what others say!</div>
            <div className="TestimonialSliderContainer">
              <Slider {...settings}>
                <div>
                  <div className="WhyWorkWithUsTestimonial" style={{
                    margin: '10px', 
                    padding: '20px', 
                    background: 'white', 
                    borderRadius: '8px',
                    overflow: 'hidden',
                    position: 'relative',
                    minHeight: 'auto',
                    height: 'auto',
                    '@media (max-width: 768px)': {
                      margin: '5px',
                      padding: '15px'
                    }
                  }}>
                    <FaQuoteLeft className="TaylrHomePageTestimonialQuote"/>
                    <div className="WhyWorkWithUsTestimonialText" style={{
                      wordWrap: 'break-word',
                      overflowWrap: 'break-word',
                      fontSize: '16px',
                      lineHeight: '1.6',
                      '@media (max-width: 768px)': {
                        fontSize: '14px',
                        lineHeight: '1.4'
                      }
                    }}>
                      <p>Aylin's knowledge of the architectural industry, combined with her passion for helping individuals advance in their careers, is truly remarkable. I can't express enough how valuable Aylin's guidance and expertise have been.</p>
                      <p>In our coaching session, Aylin took the time to listen to my concerns and dilemmas, providing thoughtful insights and practical advice to help me make important decisions. I highly recommend Aylin and ArchJobs to anyone in the architectural industry who is looking for career support, job opportunities, or valuable insights. Aylin's professionalism, expertise, and unwavering commitment make her an exceptional resource in the field. Thank you, Aylin, for your invaluable support and dedication to helping professionals thrive in their careers.</p>
                    </div>
                    <div className="ArchJobsTestimonialProfile" style={{
                      marginTop: '15px',
                      '@media (max-width: 768px)': {
                        marginTop: '10px'
                      }
                    }}>
                      <div className="TestimonialName" style={{
                        fontSize: '16px',
                        fontWeight: 'bold',
                        '@media (max-width: 768px)': {
                          fontSize: '14px'
                        }
                      }}>Elena - Architect</div>
                    </div>
                  </div>
                </div>

                <div>
                  <div className="WhyWorkWithUsTestimonial" style={{
                    margin: '10px', 
                    padding: '20px', 
                    background: 'white', 
                    borderRadius: '8px',
                    overflow: 'hidden',
                    position: 'relative',
                    minHeight: 'auto',
                    height: 'auto',
                    '@media (max-width: 768px)': {
                      margin: '5px',
                      padding: '15px'
                    }
                  }}>
                    <FaQuoteLeft className="TaylrHomePageTestimonialQuote"/>
                    <div className="WhyWorkWithUsTestimonialText" style={{
                      wordWrap: 'break-word',
                      overflowWrap: 'break-word',
                      fontSize: '16px',
                      lineHeight: '1.6',
                      '@media (max-width: 768px)': {
                        fontSize: '14px',
                        lineHeight: '1.4'
                      }
                    }}>
                      <p>I had a CV and Portfolio session with Aylin. She was very supportive and shared a lot of valuable insights in crafting your CV and Portfolio. Additionally, she also suggested how I can broaden my job hunt based on the types of projects present in my portfolio. I recommend her as good career coach for architectural professionals.</p>
                    </div>
                    <div className="ArchJobsTestimonialProfile" style={{
                      marginTop: '15px',
                      '@media (max-width: 768px)': {
                        marginTop: '10px'
                      }
                    }}>
                      <div className="TestimonialName" style={{
                        fontSize: '16px',
                        fontWeight: 'bold',
                        '@media (max-width: 768px)': {
                          fontSize: '14px'
                        }
                      }}>Sruthi - Overseas Qualified Architect/Part 2 Architectural Assistant</div>
                    </div>
                  </div>
                </div>

                <div>
                  <div className="WhyWorkWithUsTestimonial" style={{
                    margin: '10px', 
                    padding: '20px', 
                    background: 'white', 
                    borderRadius: '8px',
                    overflow: 'hidden',
                    position: 'relative',
                    minHeight: 'auto',
                    height: 'auto',
                    '@media (max-width: 768px)': {
                      margin: '5px',
                      padding: '15px'
                    }
                  }}>
                    <FaQuoteLeft className="TaylrHomePageTestimonialQuote"/>
                    <div className="WhyWorkWithUsTestimonialText" style={{
                      wordWrap: 'break-word',
                      overflowWrap: 'break-word',
                      fontSize: '16px',
                      lineHeight: '1.6',
                      '@media (max-width: 768px)': {
                        fontSize: '14px',
                        lineHeight: '1.4'
                      }
                    }}>
                      <p>The coaching session was smooth, direct, and highly effective. She provided constructive feedback on my CV and valuable insights into the firms to target. Her deep industry knowledge and approachable nature made the process both insightful and engaging.

Having recently transitioned from the UK to Dubai, I found Aylin to be the perfect person to approach, as she understood my background and the challenges of entering a new market. Her guidance not only helped me navigate the job search but also boosted my confidence.

I highly recommend Aylin to anyone seeking career coaching—her expertise and support have a meaningful impact.</p>
                    </div>
                    <div className="ArchJobsTestimonialProfile" style={{
                      marginTop: '15px',
                      '@media (max-width: 768px)': {
                        marginTop: '10px'
                      }
                    }}>
                      <div className="TestimonialName" style={{
                        fontSize: '16px',
                        fontWeight: 'bold',
                        '@media (max-width: 768px)': {
                          fontSize: '14px'
                        }
                      }}>Dana - Architect</div>
                    </div>
                  </div>
                </div>

                <div>
                  <div className="WhyWorkWithUsTestimonial" style={{
                    margin: '10px', 
                    padding: '20px', 
                    background: 'white', 
                    borderRadius: '8px',
                    overflow: 'hidden',
                    position: 'relative',
                    minHeight: 'auto',
                    height: 'auto',
                    '@media (max-width: 768px)': {
                      margin: '5px',
                      padding: '15px'
                    }
                  }}>
                    <FaQuoteLeft className="TaylrHomePageTestimonialQuote"/>
                    <div className="WhyWorkWithUsTestimonialText" style={{
                      wordWrap: 'break-word',
                      overflowWrap: 'break-word',
                      fontSize: '16px',
                      lineHeight: '1.6',
                      '@media (max-width: 768px)': {
                        fontSize: '14px',
                        lineHeight: '1.4'
                      }
                    }}>
                      <p>I had the pleasure of working with Aylin as my career coach, and I recommend her highly enough. Aylin's expertise in reviewing CVs and portfolios provided me with invaluable insights that improved my job search in the UK as a fresh graduate. Her thoughtful and constructive feedback helped me enhance my CV, making it more impactful. Aylin's guidance was not only professional but also personalized, ensuring that I received the best advice tailored to my specific career goals.</p>
                    </div>
                    <div className="ArchJobsTestimonialProfile" style={{
                      marginTop: '15px',
                      '@media (max-width: 768px)': {
                        marginTop: '10px'
                      }
                    }}>
                      <div className="TestimonialName" style={{
                        fontSize: '16px',
                        fontWeight: 'bold',
                        '@media (max-width: 768px)': {
                          fontSize: '14px'
                        }
                      }}>Maitri - Architectural Assistant</div>
                    </div>
                  </div>
                </div>

                <div>
                  <div className="WhyWorkWithUsTestimonial" style={{
                    margin: '10px', 
                    padding: '20px', 
                    background: 'white', 
                    borderRadius: '8px',
                    overflow: 'hidden',
                    position: 'relative',
                    minHeight: 'auto',
                    height: 'auto',
                    '@media (max-width: 768px)': {
                      margin: '5px',
                      padding: '15px'
                    }
                  }}>
                    <FaQuoteLeft className="TaylrHomePageTestimonialQuote"/>
                    <div className="WhyWorkWithUsTestimonialText" style={{
                      wordWrap: 'break-word',
                      overflowWrap: 'break-word',
                      fontSize: '16px',
                      lineHeight: '1.6',
                      '@media (max-width: 768px)': {
                        fontSize: '14px',
                        lineHeight: '1.4'
                      }
                    }}>
                      <p>Aylin has helped me continuously in improving my CV and gave me amazing advice. She is very helpful and I would recommend her to any graduate architects who are in need of assistance with their CV, portfolios and have any general questions about what is involved in the recruitment process and how you can gain skills to strengthen your CV.</p>
                      <p>Lovely person and great advisor!</p>
                    </div>
                    <div className="ArchJobsTestimonialProfile" style={{
                      marginTop: '15px',
                      '@media (max-width: 768px)': {
                        marginTop: '10px'
                      }
                    }}>
                      <div className="TestimonialName" style={{
                        fontSize: '16px',
                        fontWeight: 'bold',
                        '@media (max-width: 768px)': {
                          fontSize: '14px'
                        }
                      }}>Moustafa - Part 2 Architectural Assistant</div>
                    </div>
                  </div>
                </div>

                <div>
                  <div className="WhyWorkWithUsTestimonial" style={{
                    margin: '10px', 
                    padding: '20px', 
                    background: 'white', 
                    borderRadius: '8px',
                    overflow: 'hidden',
                    position: 'relative',
                    minHeight: 'auto',
                    height: 'auto',
                    '@media (max-width: 768px)': {
                      margin: '5px',
                      padding: '15px'
                    }
                  }}>
                    <FaQuoteLeft className="TaylrHomePageTestimonialQuote"/>
                    <div className="WhyWorkWithUsTestimonialText" style={{
                      wordWrap: 'break-word',
                      overflowWrap: 'break-word',
                      fontSize: '16px',
                      lineHeight: '1.6',
                      '@media (max-width: 768px)': {
                        fontSize: '14px',
                        lineHeight: '1.4'
                      }
                    }}>
                      <p>I had the pleasure of working with Aylin Round as my career coach, and I cannot recommend her highly enough. Aylin's expertise in reviewing CVs and portfolios provided invaluable insights into the market landscape. Her keen eye for detail and deep understanding of industry trends helped me refine my professional materials to stand out in today's competitive job market. Aylin's guidance not only enhanced my application but also boosted my confidence in pursuing new opportunities. If you're seeking a dedicated and knowledgeable career coach, look no further than Aylin Round.</p>
                    </div>
                    <div className="ArchJobsTestimonialProfile" style={{
                      marginTop: '15px',
                      '@media (max-width: 768px)': {
                        marginTop: '10px'
                      }
                    }}>
                      <div className="TestimonialName" style={{
                        fontSize: '16px',
                        fontWeight: 'bold',
                        '@media (max-width: 768px)': {
                          fontSize: '14px'
                        }
                      }}>Lakshmi - Urban Designer</div>
                    </div>
                  </div>
                </div>

              </Slider>
            </div>
          </div>
            <p/>
           <p/>
            <div className="WhyWorkWithUsSection ">
            <FAQCoaching/>
          </div>
          {/* <div className="WhyWorkWithUsSection ">
            <div className="FAQContainer">
              {FAQCoaching.map((faq, index) => (
                <div key={index} className="FAQItem">
                  <button 
                    className="FAQQuestion"
                    onClick={() => handleClick(index)}
                  >
                    {faq.question}
                    <span>{this.state.activeIndex === index ? '−' : '+'}</span>
                  </button>
                  <div className={`FAQAnswer ${this.state.activeIndex === index ? 'active' : ''}`}>
                    {faq.answer}
                  </div>
                </div>
              ))}
            </div>
          </div> */}
          <div className="WhyWorkWithUsSection Bottom">
          <div className="WhyWorkWithUsSectionTitle WhyWorkWithUsSectionTitleBold">Ready to take the next step in your architectural career?</div>
              <div className="WhyWorkWithUsSectionSubtitle">Whether you're targeting roles in the UK or planning a move to Dubai, choose the right session or get in touch and I’ll guide you.</div>
           <div class="coaching-contact-button">
              <a href="mailto:hello@archjobs.co.uk?subject=Coaching%20Session%20Enquiry" class="btn-get-in-touch">
                Get in Touch
              </a> 
            </div>
            {/* <div className="WhyWorthWithUsHeaderButton">
                <Button btnClassName="PostJobButton" onClickFunc = {() => {
                  // scroll to id "ChoosePackageSection" 50px above it
                  var element = document.getElementById("ChoosePackageSection");
                  var headerOffset = 50;
                  var elementPosition = element.getBoundingClientRect().top;
                  var offsetPosition = elementPosition - headerOffset;

                  window.scrollTo({
                    top: offsetPosition,
                    behavior: "smooth"
                  });

                }}>Let's Go</Button>
            </div> */}
          </div>
          <div className="BottomPadding"></div> 
          <ChatWidget />
        </div>
      )
    }
  }

  export default WhyWorkWithUsCoaching